import getUrlPath from '../../utils/getUrlPath';
import { auth } from '../../utils/auth';
import { AUTH_REDIRECT_STORAGE_KEY } from '../../constants/auth';
import { AuthRedirectData, AuthRedirectType } from '../../types/route';
import { Body } from '../Typography';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { setLocationIsSetInCurrentUserSession } from '../../redux/slice/locationSlice';
import { url } from '../../constants/url';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function AuthCallback() {
  const location = useLocation();
  const dispatch = useDispatch();

  const redirect = () => {
    let redirectUrl = window.location.origin;
    let isLoginAfterForceLogout = false;
    let enforceRedirectUrl: boolean | undefined;

    const dataFromStorage = localStorage.getItem(AUTH_REDIRECT_STORAGE_KEY);
    if (dataFromStorage) {
      const redirectData = JSON.parse(dataFromStorage) as AuthRedirectData;
      redirectUrl = redirectData.url;
      enforceRedirectUrl = redirectData.enforceRedirectUrl;
      if (redirectData.type === AuthRedirectType.LOGIN_AFTER_FORCE_LOGOUT) {
        isLoginAfterForceLogout = true;
      }
    }

    dispatch(setLocationIsSetInCurrentUserSession(false));

    setTimeout(() => {
      localStorage.removeItem(AUTH_REDIRECT_STORAGE_KEY);
      if (isLoginAfterForceLogout) {
        auth.login(redirectUrl, enforceRedirectUrl);
      } else {
        window.location.href = redirectUrl;
      }
    }, 1000);
  };

  useEffect(() => {
    const authCallbackPath = getUrlPath(url.auth.subPath.login.subPath.callback.id);

    if (location.pathname === authCallbackPath) {
      redirect();
    }
  }, []);

  return (
    <Box>
      <Body>
        <FormattedMessage id={'generic.redirecting'} />
      </Body>
    </Box>
  );
}

export default AuthCallback;
